import api from '../../api';
import ACTION_TYPES from '../../constants/actionTypes';

/**
 * Get policy summaries
 * ========================================
 */

function getPoliciesSummaryRequest() {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS,
  };
}

function getPoliciesSummarySuccess(policiesSummary) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS,
    payload: policiesSummary,
  };
}

function getPoliciesSummaryFailure(error) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_FAILURE,
    error,
  };
}

export function getPoliciesSummary() {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(getPoliciesSummaryRequest());
    return new Promise((resolve, reject) => {
      api
        .getAllPolicies({ authToken })
        .then(policiesSummary => {
          dispatch(getPoliciesSummarySuccess(policiesSummary));
          resolve(policiesSummary);
        })
        .catch(error => {
          dispatch(getPoliciesSummaryFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get policies for a vertical
 * ========================================
 */

function getPoliciesForVerticalRequest(verticalCode) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_VERTICAL,
    payload: {
      verticalCode,
    },
  };
}

function getPoliciesForVerticalSuccess(policies) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_SUCCESS,
    payload: {
      policies,
    },
  };
}

function getPoliciesForVerticalFailure(error) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_FAILURE,
    error,
  };
}

export function getPoliciesForVertical(verticalCode) {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(getPoliciesForVerticalRequest(verticalCode));
    return new Promise((resolve, reject) => {
      api
        .getPoliciesForVertical({ authToken, verticalCode })
        .then(policies => {
          dispatch(getPoliciesForVerticalSuccess(policies));
          resolve(policies);
        })
        .catch(error => {
          dispatch(getPoliciesForVerticalFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get a policy by ID
 * ========================================
 */

function getPolicyByIdRequest(policyId) {
  return {
    type: ACTION_TYPES.GET_POLICY_BY_ID,
    payload: {
      policyId,
    },
  };
}

function getPolicyByIdSuccess(policy) {
  return {
    type: ACTION_TYPES.GET_POLICY_BY_ID_SUCCESS,
    payload: {
      policy,
    },
  };
}

function getPolicyByIdFailure(error) {
  return {
    type: ACTION_TYPES.GET_POLICY_BY_ID_FAILURE,
    error,
  };
}

export function getPolicyById(policyId) {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(getPolicyByIdRequest(policyId));
    return new Promise((resolve, reject) => {
      api
        .getPolicyById({ authToken, policyId })
        .then(policy => {
          dispatch(getPolicyByIdSuccess(policy));
          resolve(policy);
        })
        .catch(error => {
          dispatch(getPolicyByIdFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get cancel policy checkout
 * ========================================
 */

function getCancelPolicyCheckoutRequest(policyId) {
  return {
    type: ACTION_TYPES.GET_CANCEL_POLICY_CHECKOUT,
    payload: {
      policyId,
    },
  };
}

function getCancelPolicyCheckoutSuccess(cancelPolicyCheckout) {
  return {
    type: ACTION_TYPES.GET_CANCEL_POLICY_CHECKOUT_SUCCESS,
    payload: cancelPolicyCheckout,
  };
}

function getCancelPolicyCheckoutFailure(error) {
  return {
    type: ACTION_TYPES.GET_CANCEL_POLICY_CHECKOUT_FAILURE,
    error,
  };
}

export function getCancelPolicyCheckout(policyId) {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(getCancelPolicyCheckoutRequest(policyId));
    return new Promise((resolve, reject) => {
      api
        .getCancelPolicyCheckout({
          authToken,
          policyId,
        })
        .then(cancelPolicyCheckout => {
          dispatch(getCancelPolicyCheckoutSuccess(cancelPolicyCheckout));
          resolve(cancelPolicyCheckout);
        })
        .catch(error => {
          dispatch(getCancelPolicyCheckoutFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Submit cancel policy
 * ========================================
 */

function cancelPolicyRequest(policyId) {
  return {
    type: ACTION_TYPES.CANCEL_POLICY,
    payload: {
      policyId,
    },
  };
}

function cancelPolicySuccess(cancelPolicyCheckout) {
  return {
    type: ACTION_TYPES.CANCEL_POLICY_SUCCESS,
    payload: cancelPolicyCheckout,
  };
}

function cancelPolicyFailure(error) {
  return {
    type: ACTION_TYPES.CANCEL_POLICY_FAILURE,
    error,
  };
}

export function cancelPolicy(policyId) {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(cancelPolicyRequest(policyId));
    return new Promise((resolve, reject) => {
      api
        .submitCancelPolicy({
          authToken,
          policyId,
        })
        .then(() => {
          dispatch(cancelPolicySuccess());
          resolve();
        })
        .catch(error => {
          dispatch(cancelPolicyFailure(error));
          reject(error);
        });
    });
  };
}
